import { render, staticRenderFns } from "./AppEchartLineAmpToday.vue?vue&type=template&id=56e1d36a&scoped=true&"
import script from "./AppEchartLineAmpToday.vue?vue&type=script&lang=js&"
export * from "./AppEchartLineAmpToday.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e1d36a",
  null
  
)

export default component.exports